export const es = {
    title: `Crear cuenta`,
    description: `Únete hoy`,
    success: `¡Cuenta creada con éxito!`,
    successInstructions: `Por favor revisa tu correo electrónico para confirmación.`,
    alreadyHaveAccount: `¿Ya tienes una cuenta?`,
    failure: `El registro falló. Por favor inténtalo de nuevo.`,
};
//# sourceMappingURL=es.js.map